/** @flow */

import {
  GetDefaultStandardScriptSuccess,
  GetDefaultStandardScriptError,
  StartDefaultStandardScriptDraftSuccess,
  ToggleEditDefaultStandardScriptModal,
  UpdateDefaultStandardScriptDraft,
  UpdateDefaultStandardScriptError,
  SetShowDisableDefaultStandardScriptModal,
  SetShowDiscardDefaultStandardScriptModal,
  SetShowCancelDefaultStandardScriptModal,
  SetShowCancelDiscardDefaultStandardScriptModal,
  SetShowSubmitDefaultStandardScriptModal,
} from "@modules/service/constants/actions";
import * as standardDefaultScriptsReducers from "./reducers";
import initialState from "./state";
import type { DefaultStandardScriptsState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: DefaultStandardScriptsState = initialState,
  action: Object,
): DefaultStandardScriptsState => {
  const act = {
    [GetDefaultStandardScriptSuccess]:
      standardDefaultScriptsReducers.onGetDefaultStandardScriptSuccess,
    [GetDefaultStandardScriptError]: standardDefaultScriptsReducers.onGetDefaultStandardScriptError,
    [StartDefaultStandardScriptDraftSuccess]:
      standardDefaultScriptsReducers.onStartDefaultStandardScriptDraftSuccess,
    [ToggleEditDefaultStandardScriptModal]:
      standardDefaultScriptsReducers.onToggleEditDefaultStandardScriptModal,
    [UpdateDefaultStandardScriptDraft]:
      standardDefaultScriptsReducers.onUpdateDefaultStandardScriptDraft,
    [UpdateDefaultStandardScriptError]:
      standardDefaultScriptsReducers.onUpdateDefaultStandardScriptError,
    [SetShowDisableDefaultStandardScriptModal]:
      standardDefaultScriptsReducers.onSetShowDisableDefaultStandardScriptModal,
    [SetShowDiscardDefaultStandardScriptModal]:
      standardDefaultScriptsReducers.onSetShowDiscardDefaultStandardScriptModal,
    [SetShowCancelDefaultStandardScriptModal]:
      standardDefaultScriptsReducers.onSetShowCancelDefaultStandardScriptModal,
    [SetShowCancelDiscardDefaultStandardScriptModal]:
      standardDefaultScriptsReducers.onSetShowCancelDiscardDefaultStandardScriptModal,
    [SetShowSubmitDefaultStandardScriptModal]:
      standardDefaultScriptsReducers.onSetShowSubmitDefaultStandardScriptModal,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
